import React from 'react'
import { Crown } from 'lucide-react'

/** "Super Admin" tag: an org Admin who can act in every OpCo (OPCO_ADMIN_EMAILS
 * or granted in the app). Shown only for Super Admins whose role works. */
export default function SuperAdminTag({ compact = false }) {
  return (
    <span
      title="Super Admin: an Admin who can act in every OpCo"
      className={`inline-flex items-center gap-1 rounded-full font-semibold whitespace-nowrap bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300 ${
        compact ? 'px-1.5 py-0.5 text-[10px] uppercase tracking-wider' : 'px-2.5 py-1 text-xs'
      }`}
    >
      <Crown className="w-3 h-3" aria-hidden="true" /> Super Admin
    </span>
  )
}
